/**
 * SupportContext - Gerencia estado de notificações do Suporte
 * 
 * Rastreia mensagens não lidas do chat de suporte para exibir
 * badge de notificação no BottomTabBar.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

const SupportContext = createContext();

export const SupportProvider = ({ children }) => {
    const [unreadCount, setUnreadCount] = useState(0);
    const [hasUnreadResponse, setHasUnreadResponse] = useState(false);

    // Marca que há uma nova resposta não lida (chamado quando IA responde)
    const notifyNewResponse = useCallback(() => {
        setUnreadCount(prev => prev + 1);
        setHasUnreadResponse(true);
    }, []);

    // Limpa notificações (chamado quando usuário abre o chat)
    const clearNotifications = useCallback(() => {
        setUnreadCount(0);
        setHasUnreadResponse(false);
    }, []);

    // Incrementa contador (para múltiplas mensagens)
    const incrementUnread = useCallback(() => {
        setUnreadCount(prev => prev + 1);
        setHasUnreadResponse(true);
    }, []);

    return (
        <SupportContext.Provider value={{
            unreadCount,
            hasUnreadResponse,
            notifyNewResponse,
            clearNotifications,
            incrementUnread,
        }}>
            {children}
        </SupportContext.Provider>
    );
};

export const useSupportNotification = () => {
    const context = useContext(SupportContext);
    if (!context) {
        throw new Error('useSupportNotification deve ser usado dentro de SupportProvider');
    }
    return context;
};

export default SupportContext;
